import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinpune() {



  const cardData = {
"keyword": "Urbania On Rent in Pune",

"headingDescription":
  "Aaradhya Travels offers premium Urbania On Rent in Pune for weddings, corporate events, airport transfers, outstation tours, family trips, business travel, and luxury group transportation requirements. Our Force Urbania fleet features comfortable seating, air-conditioning, spacious interiors, luggage space, premium pushback seats, music systems, and experienced drivers familiar with Pune city routes and highways. We ensure safe, comfortable, and punctual travel with doorstep pickup services for local and outstation journeys across Pune.",

"topPlaces": [
{
"title": "Mumbai",
"description":
"Mumbai is the financial capital of India known for Marine Drive, Gateway of India, Juhu Beach, Bollywood, shopping streets, and vibrant city life. It is one of the most popular group travel destinations from Pune for corporate tours, shopping trips, and leisure outings."
},
{
"title": "Matheran",
"description":
"Matheran is Asia’s only automobile-free hill station near Mumbai known for toy train rides, viewpoints, dense greenery, and cool weather. It is a peaceful weekend getaway for families and group travelers from Pune and Mumbai."
},
{
"title": "Alibaug",
"description":
"Alibaug is a coastal beach destination near Mumbai known for clean beaches, sea forts, water sports, and relaxed seaside atmosphere. It is a popular group tour destination for short trips from Pune."
},
{
"title": "Lonavala",
"description":
"Lonavala is a famous hill station near Mumbai and Pune known for waterfalls, caves, green valleys, and monsoon beauty. It is a highly visited weekend destination for group bus and Tempo Traveller trips."
},
{
"title": "Khandala",
"description":
"Khandala is known for scenic valleys, misty hills, and natural viewpoints. It is a short and relaxing getaway destination popular among families and group travelers from Mumbai and Pune."
},
{
"title": "Navi Mumbai",
"description":
"Navi Mumbai is a planned city known for clean infrastructure, parks, malls, and business hubs. It is commonly visited for corporate group travel, events, and city tours."
},
{
"title": "Elephanta Caves",
"description":
"Elephanta Caves are UNESCO World Heritage rock-cut caves located on an island near Mumbai known for ancient sculptures and historical significance. It is a popular heritage group tour destination."
},
{
"title": "Imagicaa Theme Park",
"description":
"Imagicaa is a large theme park near Mumbai offering rides, entertainment zones, and water parks. It is a popular destination for school trips, corporate outings, and family group tours."
},
{
"title": "Karjat",
"description":
"Karjat is a scenic green valley near Mumbai known for waterfalls, rivers, resorts, and adventure activities. It is widely chosen for weekend group trips and corporate outings."
},
{
"title": "Khopoli",
"description":
"Khopoli is known for industrial areas, waterfalls nearby, and proximity to Imagicaa theme park. It is a convenient stopover destination for group travel between Pune and Mumbai."
}
],



services: [
  {
    name: "Urbania on Rent in Pune",
    description: "Urbania on rent in Pune service provides luxury transportation for corporate travel, family vacations, airport transfers, sightseeing tours, and group travel requirements. Spacious seating and modern interiors ensure smooth journeys suitable for local and outstation travel. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, airports, and residential areas across Pune. Flexible booking options allow convenient Urbania rental reservations."
  },
  {
    name: "17 Seater Urbania on Rent Pune",
    description: "17 seater Urbania on rent Pune service offers spacious transportation for weddings, family trips, corporate travel, and tourist journeys. Comfortable seating and premium interiors ensure pleasant travel experiences suitable for medium-sized passenger groups. Professional drivers ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Pune. Flexible booking options allow convenient 17 seater Urbania reservations."
  },
  {
    name: "20 Seater Urbania Booking Pune",
    description: "20 seater Urbania booking Pune service provides dependable transportation for educational tours, office outings, wedding groups, and sightseeing journeys. Spacious seating and luggage capacity ensure comfortable travel suitable for larger passenger groups. Professional chauffeurs ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient 20 seater Urbania bookings."
  },
  {
    name: "Urbania for Outstation Pune",
    description: "Urbania for outstation Pune service provides premium long-distance transportation for Goa tours, hill station vacations, pilgrimage journeys, and family trips. Spacious seating and smooth highway travel ensure comfortable journeys suitable for all passenger groups. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Pune. Flexible booking options allow convenient outstation Urbania reservations."
  },
  {
    name: "Urbania Van Rent Pune",
    description: "Urbania van rent Pune service offers reliable transportation for corporate travel, airport transfers, sightseeing tours, and family outings. Comfortable seating and spacious interiors ensure pleasant journeys suitable for local and outstation passenger movement. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and railway stations across Pune. Flexible booking options allow convenient Urbania van rental reservations."
  },
  {
    name: "Pune Urbania Traveller On Rent Price",
    description: "Pune Urbania traveller on rent price service provides affordable luxury transportation for weddings, business travel, sightseeing journeys, and family vacations. Spacious seating and luggage space ensure smooth journeys suitable for premium group travel requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and airports across Pune. Flexible booking options allow convenient Urbania traveller reservations."
  },
  {
    name: "Urbania Hire Pune to Mumbai",
    description: "Urbania hire Pune to Mumbai service offers comfortable transportation for business trips, airport transfers, sightseeing tours, and family travel. Spacious seating and smooth expressway travel ensure pleasant journeys suitable for local and intercity passenger movement. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, offices, and airports across Pune. Flexible booking options allow convenient Pune to Mumbai Urbania reservations."
  },
  {
    name: "Urbania for Pune Darshan",
    description: "Urbania for Pune Darshan service provides dependable transportation for sightseeing tours, tourist visits, heritage travel, and family outings across Pune city attractions. Spacious seating and modern interiors ensure comfortable journeys suitable for local tourism and group travel requirements. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the tour route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient Pune Darshan Urbania reservations."
  },
  {
    name: "Urbania Booking Pune Airport",
    description: "Urbania booking Pune Airport service provides dependable transportation for airport transfers, tourist groups, business travelers, and family travel requirements. Spacious seating and luggage space ensure comfortable journeys suitable for local and outstation airport transportation. Professional chauffeurs ensure timely airport pickups and safe driving services throughout the route. Pickup services are available from Pune Airport, homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient airport Urbania bookings."
  },
  {
    name: "Luxury Urbania on Rent in Pune",
    description: "Luxury Urbania on rent in Pune service provides premium transportation with elegant interiors and comfortable seating for weddings, corporate travel, airport transfers, and family vacations. Smooth highway travel ensures pleasant journeys suitable for executive passengers and tourist groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and airports across Pune. Flexible booking options allow convenient luxury Urbania reservations."
  },
  {
    name: "Urbania on Rent in Pimpri Chinchwad",
    description: "Urbania on rent in Pimpri Chinchwad service offers spacious transportation for corporate travel, family vacations, wedding functions, and airport transfers. Comfortable seating and luggage capacity ensure smooth journeys suitable for local and outstation passenger movement. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pimpri Chinchwad Pune. Flexible booking options allow convenient Urbania rental reservations."
  },
  {
    name: "Urbania on Rent in PCMC",
    description: "Urbania on rent in PCMC service provides dependable transportation for office travel, sightseeing journeys, airport transfers, and family group travel requirements. Spacious interiors and premium seating ensure pleasant journeys suitable for local and outstation transportation. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across PCMC Pune. Flexible booking options allow convenient Urbania reservations."
  },
  {
    name: "17 Seater Urbania on Rent Pimpri",
    description: "17 seater Urbania on rent Pimpri service offers luxury transportation for family outings, weddings, business travel, and airport transfers. Comfortable seating and smooth travel ensure pleasant journeys suitable for medium-sized passenger groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pimpri Pune. Flexible booking options allow convenient 17 seater Urbania reservations."
  },
  {
    name: "20 Seater Urbania Traveller in Chinchwad",
    description: "20 seater Urbania traveller in Chinchwad service provides spacious transportation for office outings, family tours, wedding groups, and sightseeing journeys. Comfortable seating and luggage space ensure smooth travel suitable for larger passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Chinchwad Pune. Flexible booking options allow convenient 20 seater Urbania traveller reservations."
  },
  {
    name: "Pimpri Chinchwad Urbania on Rent",
    description: "Pimpri Chinchwad Urbania on rent service provides reliable transportation for airport transfers, family vacations, corporate travel, and local sightseeing tours. Spacious seating and premium interiors ensure comfortable journeys suitable for local and outstation travel requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and airports across Pimpri Chinchwad Pune. Flexible booking options allow convenient Urbania rental reservations."
  },
  {
    name: "Urbania Van on Rent PCMC",
    description: "Urbania van on rent PCMC service offers dependable transportation for weddings, educational tours, office travel, family outings, and airport pickup requirements. Spacious interiors and smooth travel ensure pleasant journeys suitable for medium and large passenger groups. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, schools, hotels, and offices across PCMC Pune. Flexible booking options allow convenient Urbania van rental reservations."
  },
  {
    name: "Urbania Luxury Vehicle on Rent Pimpri",
    description: "Urbania luxury vehicle on rent Pimpri service provides premium transportation with modern interiors and spacious seating for corporate travel, weddings, sightseeing tours, and family vacations. Smooth highway travel ensures pleasant journeys suitable for executive passengers and tourist groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and airports across Pimpri Pune. Flexible booking options allow convenient luxury Urbania reservations."
  },
  {
    name: "Urbania Hire in Pimpri Chinchwad",
    description: "Urbania hire in Pimpri Chinchwad service offers spacious transportation for office staff, family tours, wedding travel, and airport transfers. Comfortable seating and luggage capacity ensure smooth journeys suitable for local and outstation passenger movement. Professional chauffeurs ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pimpri Chinchwad Pune. Flexible booking options allow convenient Urbania hire reservations."
  },
  {
    name: "Urbania Traveller Booking in PCMC",
    description: "Urbania traveller booking in PCMC service provides dependable transportation for sightseeing tours, holiday vacations, business trips, and family group travel. Spacious seating and smooth travel ensure comfortable journeys suitable for local and outstation transportation requirements. Professional drivers ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, airports, and residential areas across PCMC Pune. Flexible booking options allow convenient Urbania traveller booking reservations."
  }
],

tableData: [
  ["Urbania on Rent in Pune", "17 Seater Urbania on Rent Pune"],
  ["20 Seater Urbania Booking Pune", "Urbania for Outstation Pune"],
  ["Urbania Van Rent Pune", "Pune Urbania Traveller On Rent Price"],
  ["Urbania Hire Pune to Mumbai", "Urbania for Pune Darshan"],
  ["Urbania Booking Pune Airport", "Luxury Urbania on Rent in Pune"],
  ["Urbania on Rent in Pimpri Chinchwad", "Urbania on Rent in PCMC"],
  ["17 Seater Urbania on Rent Pimpri", "20 Seater Urbania Traveller in Chinchwad"],
  ["Pimpri Chinchwad Urbania on Rent", "Urbania Van on Rent PCMC"],
  ["Urbania Luxury Vehicle on Rent Pimpri", "Urbania Hire in Pimpri Chinchwad"],
  ["Urbania Traveller Booking in PCMC", "Urbania for Outstation Pune"]
],





 whychoose: [
      {
        WhyChooseheading: "Reliable Urbania On Rent in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable Urbania rental service in Pune with luxury vehicles, professional drivers, and smooth travel arrangements for family trips, corporate tours, weddings, and group travel."
      },
      {
        WhyChooseheading: "Affordable Luxury Urbania Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Urbania on rent in Pune with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Urbania Booking Service",
        WhyChoosedescription: "Our Force Urbania rental service in Pune operates 24 hours for airport transfers, weddings, outstation tours, pilgrimage trips, corporate outings, and luxury group travel."
      },
      {
        WhyChooseheading: "Comfortable AC Luxury Urbania Vehicles",
        WhyChoosedescription: "All Urbania vehicles provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained for premium and comfortable group travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, pilgrimage journeys, sightseeing travel, and multi-day outstation packages according to customer requirements."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Urbania Options",
        WhyChoosedescription: "Customers can choose from 9 seater, 13 seater, 17 seater, and luxury Force Urbania vehicles suitable for family vacations, corporate groups, wedding guests, and tourist travel."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Pune Airport, railway stations, hotels, and all major Pune locations."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Outstation Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local sightseeing and outstation luxury group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is Urbania on rent in Pune?", answer: "Urbania on rent in Pune provides luxury group transportation using premium Force Urbania vehicles for family tours, corporate travel, weddings, and outstation journeys." },
    { question: "Is Urbania booking available 24 hours in Pune?", answer: "Yes, Aaradhya Travels provides 24/7 Force Urbania rental service in Pune." },
    { question: "Which seating options are available in Urbania?", answer: "Aaradhya Travels offers 9 seater, 13 seater, and 17 seater Force Urbania vehicles for different group travel requirements." },
    { question: "Can I book Urbania for outstation trips from Pune?", answer: "Yes, customers can book Force Urbania for hill stations, pilgrimage tours, holiday trips, destination weddings, and outstation travel from Pune." },
    { question: "Do you provide Urbania for corporate events in Pune?", answer: "Yes, Aaradhya Travels provides Force Urbania service for office outings, conferences, employee transport, and corporate travel." },
    { question: "Are all Urbania vehicles air-conditioned?", answer: "Yes, all Force Urbania vehicles are fully air-conditioned and maintained for comfortable luxury travel." },
    { question: "Can I book Urbania online in Pune?", answer: "Yes, customers can easily book Force Urbania rental service online or through phone booking." },
    { question: "Do you provide Pune Airport pickup and drop service?", answer: "Yes, Aaradhya Travels provides airport pickup and drop service using luxury Force Urbania vehicles." },
    { question: "Are Urbania rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Urbania rental service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Rohit Patil",
      feedback:
        "Booked Urbania on rent in Pune with Aaradhya Travels for our family trip. Luxury vehicle, punctual service, and excellent driver support.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Snehal Kulkarni",
      feedback:
        "Excellent Force Urbania rental service in Pune. Clean vehicle, affordable pricing, and smooth travel experience for our group tour.",
      rating: 5
    }
  ];
  


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania on Rent in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/urbania-on-rent-in-pune.jpg",
  "description": "Book Force Urbania on rent in Pune with Aaradhya Travels for luxury group travel, corporate trips, airport transfers, weddings, and outstation journeys. Available 17 and 20 seater premium Urbania vans for Pune, Mumbai, and nearby destinations.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "11350"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/urbania-on-rent-pune"
  }
};







  return (
    <div>
<Helmet>
  <title>
    Urbania on Rent in Pune | Luxury 17 & 20 Seater Van Hire | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Force Urbania on rent in Pune with Aaradhya Travels. Premium 17 and 20 seater luxury vans for corporate travel, weddings, airport pickup, Pune Darshan, and outstation trips to Mumbai and nearby destinations."
  />

  <meta
    name="keywords"
    content="Urbania on Rent in Pune, 17 Seater Urbania on Rent Pune, 20 Seater Urbania Booking Pune, Urbania for Outstation Pune, Urbania Van Rent Pune, Pune Urbania Traveller On Rent Price, Urbania Hire Pune to Mumbai, Urbania for Pune Darshan, Urbania Booking Pune Airport, Luxury Urbania on Rent in Pune, Urbania on Rent in Pimpri Chinchwad"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/83.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Urbaniaonrentinpune ;